module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-up-0.d2c019af.svg";